import { useState } from 'react'
import './ContactForm.css'

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle')

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setStatus('submitting')

    const form = e.currentTarget
    const formData = new FormData(form)

    try {
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      })
      setStatus('success')
      form.reset()
      setTimeout(() => setStatus('idle'), 3000)
    } catch {
      setStatus('error')
      setTimeout(() => setStatus('idle'), 3000)
    }
  }

  return (
    <form className="contact-form" name="contact" onSubmit={handleSubmit} data-netlify="true" data-netlify-honeypot="bot-field">
      <input type="hidden" name="form-name" value="contact" />
      <p className="hidden-field">
        <label>Leave this field empty<input name="bot-field" tabIndex={-1} autoComplete="off" /></label>
      </p>
      <input
        type="text" 
        name="name" 
        placeholder="Your name" 
        required 
        disabled={status === 'submitting'}
      />
      <input
        type="email"
        name="email"
        placeholder="Email address"
        required
        disabled={status === 'submitting'}
      />
      <textarea
        name="message"
        rows={4}
        placeholder="Brief description of your situation"
        disabled={status === 'submitting'}
      />
      <button 
        type="submit" 
        className="cta-button"
        disabled={status === 'submitting'}
      >
        {status === 'submitting' && 'Sending...'}
        {status === 'success' && 'Message Sent'}
        {status === 'error' && 'Error - Try Again'}
        {status === 'idle' && 'Begin Conversation'}
      </button>
    </form>
  )
}

export default ContactForm
